<template>
  <div class="index">
    <my-header @form="getForm" :HideForm="HideForm" @changeStatus="changeStatus" :UserInfo="UserInfo"></my-header>
    <div class="number">
      <div class="amount-model-mod">
        <div class="amount-model-p1">
          <div class="text-0">Choose a method to pay</div>
          <div class="number-text">
            <div class="text-1"> {{ UserInfo.currencyIcon }}</div>
            <div class="text-2">{{ parseInt(Params.amount || '0').toLocaleString() }}</div>
          </div>
          <!--          -->
          <div class="tebs">
            <div v-if="UserInfo.showCardFlag == 1 " @click="active = 1"
                 :class="['tab-item',  active === 1? 'tab-active' : '']">Cards
            </div>
            <div v-if="UserInfo.showVirtualAccountFlag == 1 " @click="active = 2"
                 :class="['tab-item',  active === 2? 'tab-active' : '']">Transfer
            </div>
            <div v-if="UserInfo.showUssdFlag == 1 " @click="active = 3"
                 :class="['tab-item',  active === 3? 'tab-active' : '']">USSD
            </div>
          </div>
        </div>
      </div>
      <div class="tab-content-mod">
        <div class="tab-content">
          <div v-show="active === 1" class="tab-content-item" v-if="UserInfo.showCardFlag == 1 ">
            <h1 class="model-switch-title">Pay with Card</h1>
            <bank-card v-show="UserInfo.payChannelType === 76" v-if="UserInfo.payChannelType === 76"
                       @GetShowList="GetShowList" :Params="Params"
                       :UserInfo="UserInfo"></bank-card>

            <card v-else @GetShowList="GetShowList" :Params="Params" :UserInfo="UserInfo"></card>
          </div>
          <div v-show="active === 2" class="tab-content-item" v-if="UserInfo.showVirtualAccountFlag == 1 ">
            <h1 class="model-switch-title">Pay with Transfer</h1>
            <transfer @GetShowList="GetShowList" :Params="Params" :UserInfo="UserInfo"></transfer>
          </div>
          <div v-show="active === 3" class="tab-content-item" v-if="UserInfo.showUssdFlag == 1 ">
            <h1 class="model-switch-title">Pay with USSD</h1>
            <ussd @GetShowList="GetShowList" :Params="Params" :UserInfo="UserInfo"></ussd>
          </div>

          <div class="bottom-tips"
               v-if="UserInfo.logoEmail"
               v-clipboard:copy="UserInfo.logoEmail || ' '"
               v-clipboard:success="firstCopySuccess"
               v-clipboard:error="firstCopyError"
          >
            If you have any questions，connect us by email
            Email address:
            <span>
            <span style="vertical-align: middle;color: #000000">{{ UserInfo.logoEmail }}</span>
            <img style="width: 0.21rem; height: 0.21rem;vertical-align: middle;" src="../../assets/images/copy@3x.png">
          </span>
          </div>
          <!--        底部文字-->
          <div class="bottom-box">
            <img class="bottom-img" src="../../assets/images/suo@2x.png">
            <div class="bottom-text">{{ UserInfo.logoAuthInfo }}</div>
          </div>
        </div>
      </div>
    </div>

    <van-overlay :show="overlayStatus">
      <van-loading color="#1989fa" size="60px"/>
    </van-overlay>
    <!--    <div class="footer">{{UserInfo.logoAuthInfo}}</div>-->
    <success ref="success"></success>
    <timeout ref="timeout"></timeout>
    <fail ref="fail"></fail>
  </div>
</template>
<script>
import MyHeader from './components/header.vue'
import Transfer from './components/transfer.vue'
import Card from './components/card.vue'
import BankCard from './components/bankCard.vue'
import Ussd from './components/ussd.vue'
import md5 from 'js-md5';
import success from './success.vue';
import timeout from './timeout.vue';
import fail from './fail.vue';


import {encryption} from '../../utils/requestUtils.js'
import axios from "axios";

export default {
  data() {
    return {
      HideForm: true,
      Form_transfer: false,
      Form_card: false,
      Form_ussd: false,
      Params: {},
      UserInfo: {},
      overlayStatus: false,
      activeName: '1',
      active: 2,
      showModal: false,
    }
  },
  components: {
    MyHeader,
    Transfer,
    Card,
    Ussd,
    BankCard,
    success,
    timeout,
    fail
  },
  mounted() {
    this.getParams()
    this.getUserInfo()
    this.payment()
    this.openModal()
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    firstCopySuccess(e) {
      this.$toast("Account copied successfully!")
    },
    firstCopyError(e) {
      this.$toast("Failure!")
    },
    getForm(methods) {
      if (methods == 'transfer') {

        //this.HideForm = false
        this.Open_flag()
        setTimeout(() => {
          this.Form_transfer = true
        }, 200)

      } else if (methods == 'card') {

        //this.HideForm = false
        this.Open_flag()

        setTimeout(() => {
          this.Form_card = true
        }, 200)

      } else if (methods == 'ussd') {

        //this.HideForm = false
        this.Open_flag()

        setTimeout(() => {
          this.Form_ussd = true
        }, 200)

      }

    },
    GetShowList() {
      this.HideForm = false
    },
    changeStatus() {
      this.HideForm = true
    },
    Open_flag() {
      this.Form_transfer = false
      this.Form_card = false
      this.Form_ussd = false
    },
    getParams() {
      // 'merchantId=999&
      // merchantOrderId=1000&
      // amount=100.00&
      // abc#123!'
      this.Params = this.$route.query
      // 签名
      const sign = md5(`merchantId=${this.Params.merchantId}&merchantOrderId=${this.Params.merchantOrderId}&amount=1${parseInt(this.Params.amount || '0').toLocaleString()}&abc#123!`)
    },
    getUserInfo() {
      this.overlayStatus = true
      // this.UserInfo = {
      //   // paymentOutTime: '2023-04-17 15:20:00'
      //   timeoutSeconds: '10',
      //   timeoutStr: "29.57",
      //   logoEmail: '123132123'
      // }

      this.axios.post('/api/order/paymentStatus', {
        requestParam: encryption({
          merchantId: this.Params.merchantId,
          merchantOrderId: this.Params.merchantOrderId
        })
      }).then(res => {
          this.overlayStatus = false
          if (res.data.code == 0) {
            this.UserInfo = res.data.data
            this.Form_transfer = true
            if (this.UserInfo.showVirtualAccountFlag == 1) {
              this.active = 2;
            }  else if (this.UserInfo.showCardFlag == 1) {
              this.active = 1;
            } else if (this.UserInfo.showUssdFlag == 1) {
              this.active = 3;
            }
          } else {
            this.$toast(res.data.error)
          }
          // setTimeout(()=>{this.overlayStatus = false},1000)
        }
      )
    },
    payment() {
      this.axios.post('/api/order/paymentStatus', {
        requestParam: encryption({
          merchantId: this.Params.merchantId,
          merchantOrderId: this.Params.merchantOrderId
        })
      }).then(res => {
        if (res.data.data.status == 0) {
          if (res.data.data.timeoutSeconds <= 0) {
            this.$refs.timeout.openDialog()
          } else {
            setTimeout(() => {
              this.payment()
            }, 2000)
          }
          this.UserInfo = res.data.data
        } else if (res.data.data.status == 1) {
          this.$refs.success.openDialog(res.data.data.callbackUrl)
        } else if (res.data.data.status == 2) {
          this.$refs.fail.openDialog(res.data.data.callbackUrl)
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.index {
  padding: 10px 20px;
  margin: 0 auto;

  @media (min-width: 1000px) {
    padding: 0;
    .amount-model-mod {
      border-radius: inherit;

      .amount-model-p1 {
        max-width: 14rem;
        margin: 0 auto;
      }
    }
    .tab-content {
      max-width: 15rem;
    }
  }
}

.bottom-tips {
  text-align: left;
  font-size: 0.23rem;
  font-weight: bold;
}

.bottom-box {
  margin-top: 0.3rem;
  display: flex;
  justify-content: center;
  align-items: center;

  .bottom-img {
    width: 0.30rem;
    height: 0.30rem;
    margin-right: 0.04rem;
    vertical-align: middle;
  }

  .bottom-text {
    vertical-align: middle;
    font-size: 0.24rem;
    color: #000000;
    font-weight: bold;
  }
}

.tab-content {
  text-align: center;
  margin: 0.45rem auto;
  padding-bottom: 0.35rem;

  .tab-content-item {
    text-align: center;

    .model-switch-title {
      text-align: left;
      font-size: 0.34rem;
    }
  }
}

.tab-active {
  color: #FFFFFF !important;
  background-color: #283B51 !important;
}

.tebs {
  display: flex;
  justify-content: space-between;

  .tab-item {
    flex: 1;
    margin: 0 0.13rem;
    height: 1rem;
    background-color: #F5F7FA;
    color: #283B51;
    border-radius: 0.32rem 0.32rem 0.32rem 0.32rem;
    font-size: 0.28rem;
    line-height: 1rem;
    font-weight: 500;
  }
}

.number {
  width: 100%;
  position: relative;
  padding-bottom: 2.47rem;

  .tab-content-mod {
    width: 100%;
  }
}

.amount-model-mod {
  border-radius: 0.48rem;
  background-color: #DCE8F5;
  padding: 16px 10px;

  .text-0 {
    display: inline-flex;
    color: #446388;
    font-size: 0.35rem;
  }

  .number-text {
    width: 6.2rem;
    height: 1.85rem;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;

    .text-1 {
      font-size: 0.81rem;
      color: #283B51;
    }

    .text-2 {
      font-family: PingFang SC;
      font-size: 0.81rem;
      color: #283B51;
      margin-left: 0.08rem;
    }
  }
}


.van-loading {
  margin-top: 50%;
}

.choose_title {
  text-align: left;

  em {
    font-style: normal;
    margin-left: 0.3rem;
  }

  span {

  }
}

.footer {
  text-align: center;
  font-size: 0.24rem;
  margin-top: 2rem;
  margin-bottom: 1rem;
}

/* 在你的样式表中 */
.custom-swal-content {
  font-size: 0.1rem !important; // 设置字体大小
  /* 其他自定义样式 */
}


</style>



// WEBPACK FOOTER //
// src/pages/ngn/index.vue